import { uniqueId, uniqueJId } from '../../../helpers/unique-id';

function createNode({ parent, type, value, id, _id: uId, jId, substituteJId }) {
  const data = {
    _id: uId,
    type,
    value,
    parent,
    id,
    jId,
    substituteJId,
  };

  return data;
}

export function convertTreeData(inputData) {
  if (!inputData) {
    return [];
  }

  const data = [];

  function getValue(jLegId = 'root', jId = '1', parent = null) {
    const id = `${jLegId}#${jId}`;
    const target = inputData[`${id}:TGT`] || inputData[`${id}:target`];
    const stoploss = inputData[`${id}:SL`] || inputData[`${id}:stoploss`];

    const targetId = uniqueId();
    const stoplossId = uniqueId();
    const [, substituteTargetJId = uniqueJId()] = target
      ? target.split('#')
      : [];
    const [, substituteStoplossJId = uniqueJId()] = stoploss
      ? stoploss.split('#')
      : [];

    if (target) {
      data.push(
        createNode({
          parent,
          type: 'target',
          value: target?.split('#')[0],
          _id: targetId,
          id,
          jId,
          substituteJId:
            target && target !== 'STOP' ? substituteTargetJId : undefined,
        })
      );
    }

    if (stoploss) {
      data.push(
        createNode({
          parent,
          type: 'stoploss',
          value: stoploss?.split('#')[0],
          _id: stoplossId,
          id,
          jId,
          substituteJId:
            stoploss && stoploss !== 'STOP' ? substituteStoplossJId : undefined,
        })
      );
    }

    if (target && target !== 'STOP') {
      const [targetJLegId, targetJId] = target.split('#');

      getValue(targetJLegId, targetJId, targetId);
    }

    if (stoploss && stoploss !== 'STOP') {
      const [stoplossJLegId, stoplossJId] = stoploss.split('#');

      getValue(stoplossJLegId, stoplossJId, stoplossId);
    }
  }

  getValue();

  const dataWithChildren = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    const children = data
      .filter((item) => item.parent === element._id)
      ?.map((item) => item._id);

    if (children.length) {
      dataWithChildren.push({
        ...element,
        children,
      });
    } else {
      dataWithChildren.push(element);
    }
  }

  return dataWithChildren;
}

export function convertNormalDataToTreeData(data) {
  if (!data.length) {
    return {};
  }

  const dataObject = {};

  function generateObjectData(items = [], parentElement = null) {
    items.forEach((item) => {
      const valueId = `${parentElement?.value}#${item?.jId}`;
      const id = item.id ? item.id : valueId;

      const type = item.type === 'stoploss' ? 'SL' : 'TGT';

      dataObject[`${id}:${type}`] = `${item.value}`;

      const childNodes = data.filter((citem) => citem.parent === item._id);

      if (childNodes.length) {
        generateObjectData(childNodes, item);

        const childJid = childNodes[0].jId;

        if (childJid) {
          dataObject[`${id}:${type}`] = `${item.value}#${childJid}`;
        }
      } else if (item.value !== 'STOP') {
        const substituteJId = item.substituteJId || uniqueJId();

        dataObject[`${id}:${type}`] = `${item.value}#${substituteJId}`;
      }
    });
  }

  const rootData = data.filter((item) => !item.parent);

  generateObjectData(rootData, null);

  return dataObject;
}
